import { Box, Typography } from '@mui/material';
import React from 'react';
import { Fragment } from 'react';
import cssClasses from './DigitalCostSheet.module.css';
import CustomInput from '../../Subcomponents/CustomInput';
import Button from '../../Subcomponents/Button';
import _ from 'lodash';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import galleryImg from '../../Assets/Images/Common/gallery.svg'
import { useState } from 'react';
import { useEffect } from 'react';
import { dismissLoader, presentLoader } from '../../Services/loader';
import { UpdateProjectTnC, getProjectById, uploadDigitCostBannerImg } from '../../Services/Project';
import { errorTost, successTost } from '../../Services/Toast';
import CustomSwitch from '../../Subcomponents/CustomSwitch';
import ViewPayloadAndErrorDetailsModal from '../AllAllotments/CrmAllotment/ViewCrmDetailsModal/ViewPayloadAndErrorDetailsModal';

const helperText = {
  fontSize: '1.4rem !important',
  margin: '0rem 0 0 0 !important',
  fontFamily: 'Inter-Medium !important',
  lineHeight: '1.8rem !important',
  paddingTop: '0.5rem !important ',
  color: '#d32f2f',
};

const DigitalCostSheet = ({ projectData }) => {
  const [conditionTemplate, setConditionTemplate] = useState(
    projectData[0]?.digitalCostSheetTnc
      ? projectData[0]?.digitalCostSheetTnc
      : ''
  );
  const [conditionTemplateHelperText, setConditionTemplateHelperText] =
    useState('');
  const [ImageHelperText, setImageHelperText] =
    useState('');
  // const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const [uploadImage, setUploadImage] = useState(null)
  const [isDisable, setIsDisable] = useState(projectData?.[0]?.isDigitalCostSheetDisable);
  const [copyUrlModal, setCopyUrlModal] = useState(false);
  const [copyUrl, setCopyUrl] = useState(`${window.location.protocol}//${window.location.host}/Digital-Cost-Sheet/${projectData?.[0]?.projectId}`);

  useEffect(() => {
    if (conditionTemplate === '') {
      setConditionTemplateHelperText('Please Enter valid value.');
    }
  }, [conditionTemplate]);

  useEffect(() => {
    if (uploadImage === '') {
      setImageHelperText('Please upload Image.');

    }

  }, [uploadImage]);

  useEffect(() => {
    if (uploadImage) {
      document.getElementById('eventBannerImg').src = window.URL.createObjectURL(uploadImage)
    }
  }, [uploadImage])


  const getProjectData = () => {
    presentLoader();
    getProjectById(projectData[0]?.buId, projectData[0]?.type)
      .then((res) => {
        setConditionTemplate(res?.data[0]?.digitalCostSheetTnc);
        dismissLoader();
      })
      .catch((err) => {
        errorTost(err.message);
        dismissLoader();
      });
  };


  function convertImageFileToWebFile(file) {
    return new Promise((resolve, reject) => {
      if (file.type.includes("image/")) {
        const image = new Image();
        image.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = image.naturalWidth;
          canvas.height = image.naturalHeight;
          canvas.getContext("2d").drawImage(image, 0, 0);
          canvas.toBlob((blob) => {
            let myFile = new File([blob], `${file.name.split(".")[0]}.webp`, {
              type: blob.type,
            });
            resolve(myFile);
          }, "image/webp");
        };
        image.onerror = (err) => { };
        image.crossOrigin = "anonymous";
        image.src = URL.createObjectURL(file);
      } else {
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
          let myFile = new File([e.target.result], file.name, {
            type: file.type,
          });
          // let myFile = e.target.result;
          resolve(myFile);
        };
        fileReader.onerror = (err) => { };
        fileReader.readAsArrayBuffer(file);
      }
      // const image = new Image();
      // image.onload = () => {
      //     const canvas = document.createElement("canvas");
      //     canvas.width = image.naturalWidth;
      //     canvas.height = image.naturalHeight;
      //     canvas.getContext("2d").drawImage(image, 0, 0);
      //     canvas.toBlob((blob) => {
      //         let myFile = new File([blob], "my-new-group-image.webp", {
      //             type: blob.type,
      //         });
      //         resolve(myFile);
      //     }, "image/webp");
      // };
      // image.crossOrigin = "anonymous";
      // image.src = URL.createObjectURL(file);
    });
  }

  const handleSubmit = () => {
    presentLoader();
    const obj = {
      digitalCostSheetTnc: conditionTemplate,
      isDigitalCostSheetDisable : isDisable
    };
    if (uploadImage) {
      convertImageFileToWebFile(uploadImage).then((file) => {
        console.log("file", file)
        uploadDigitCostBannerImg(file, projectData[0]?.projectId).then((uploadResp) => {
          console.log("uploadREsp", uploadResp)

          UpdateProjectTnC(obj, projectData[0]?.projectId)
            .then(() => {
              dismissLoader();
              successTost('Digital Cost Sheet Details added Successfully.');
              getProjectData();
            })
            .catch((Err) => {
              errorTost(Err.message);
              dismissLoader();
            });
        })

      })
    } else {
      UpdateProjectTnC(obj, projectData[0]?.projectId)
        .then(() => {
          dismissLoader();
          successTost('Digital Cost Sheet Details added Successfully.');
          getProjectData();
        })
        .catch((Err) => {
          errorTost(Err.message);
          dismissLoader();
        });
    }


  };

  return (
    <div className={cssClasses.wingContainer}>
      {/* <div className={cssClasses.wingWrapper}>
        <Box>
          <CustomInput
            disabled={true}
            label={"Wing Name"}
           // placeholder={val?.wingName}
            inputType={"number"}
          />
        </Box>
        <Box>
          <CustomInput
            //value={val?.displayName}
            label={"Display Wing Name"}
            placeholder={""}
            inputType={"text"}
            // handleChange={(_value) => {
            //   const index = wings?.findIndex(
            //     (v) => v.wingId === val?.wingId
            //   );
            //   const payload = [...wings];
            //   payload[index].displayName = _value;
            //   setWings(payload);
            // }}
          />
        </Box>
        <Box>
          <CustomInput
           // value={val?.displayName}
            label={"Display Wing Name"}
            placeholder={""}
            inputType={"text"}
            // handleChange={(_value) => {
            //   const index = wings?.findIndex(
            //     (v) => v.wingId === val?.wingId
            //   );
            //   const payload = [...wings];
            //   payload[index].displayName = _value;
            //   setWings(payload);
            // }}
          />
        </Box>
      </div> */}
      <div className={cssClasses.container}>
        <div>
          <Button
            style={{
              color: "#344054",
              backgroundColor: "#ffffff",
              fontSize: "1.4rem",
              lineHeight: "2rem",
              width : "15rem"
            }}
            padding={"0.85rem 3rem"}
            btnName={"Copy URL"}
            clicked={() => setCopyUrlModal(true)}
          />
        </div>
        <div className={cssClasses.toggleWrapper}>
          <Box className={cssClasses.Title1}>
              Disable
          </Box>
          <CustomSwitch
            checked={isDisable}
            onChange={(event) => {
              setIsDisable(event.target.checked);
            }}
          />
        </div>
      </div>
      <div className={cssClasses?.termsWrapper}>
        <label>Image Upload</label>
        <div
          className={cssClasses.upload}
          onClick={() => {
            document.getElementById('imgupload').click();
          }}
        >
          {projectData[0]?.bannerImages || uploadImage ? (
            <div className={cssClasses.uploadInputImg}>
              <Box height={'100%'} width={'fit-Content'}>
                <img
                  className={cssClasses.uploadedImg}
                  id='eventBannerImg'
                  src={
                    projectData[0]?.bannerImages
                      ? process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                      projectData[0]?.bannerImages +
                      `?${Date.now()}`
                      : ''
                  }
                  alt=''
                />
              </Box>

              <input
                hidden
                type='file'
                accept='image/*'
                id='imgupload'
                name=''
                onChange={(e) => {
                  console.log("e->", e)


                  if (e.target.files[0]) {
                    setUploadImage(e.target.files[0]);
                    setImageHelperText('');

                  } else {
                    setImageHelperText("Please upload Image")
                  }


                }}
              />
              <div className={cssClasses.reupload}>
                <div className={cssClasses.uploadImg1}>
                  <img src={galleryImg} alt='' />
                </div>
                <div className={cssClasses.uplaodLabel1}>
                  <p>Upload here</p>
                </div>
              </div>
            </div>
          ) : (
            <div className={cssClasses.uploadInput}>
              <div className={cssClasses.uploadImg}>
                <img src={galleryImg} alt='' />
              </div>
              <div className={cssClasses.uplaodLabel}>
                <p>Upload here</p>
              </div>
              <input
                hidden
                type='file'
                accept='image/*'
                id='imgupload'
                name=''
                onChange={(e) => {
                  console.log("e", e.target.files[0])
                  setUploadImage(e.target.files[0]);

                  if (e.target.files[0]) {
                    setImageHelperText('');

                  } else {
                    setImageHelperText("Please upload Image")
                  }


                }}
              />
            </div>
          )}
        </div>
        {ImageHelperText && (
          <Typography sx={{ ...helperText }}>
            {' '}
            {ImageHelperText}{' '}
          </Typography>
        )}
      </div>

      <div className={cssClasses?.termsWrapper}>
        <label>Terms & Conditions</label>
        <Box className={`ck-height-apply `}>
          <CKEditor
            editor={ClassicEditor}
            config={{
              //    plugins: [Heading, 'Paragraph', 'Bold', 'Italic', 'Essentials','List' ],
              toolbar: [
                'paragraph',
                'heading1',
                'heading2',
                'heading3',
                'heading4',
                'heading5',
                'heading6',
                'alignment',
                'heading',
                '|',
                'bold',
                'italic',
                'link',
                'bulletedList',
                'numberedList',
                'blockQuote',
                'undo',
                'redo',
              ],
            }}
            data={conditionTemplate}
            onReady={(editor) => {
              // You can store the "editor" and use when it is needed.
              // console.log('Editor is ready to use!', editor);
            }}
            onChange={(event, editor) => {
              const data = editor.getData();
              console.log(data);

              if (data) {
                setConditionTemplateHelperText('');

              } else {
                setConditionTemplateHelperText('Please Enter valid value.');
              }
              setConditionTemplate(data);
            }}
            onBlur={(event, editor) => {
              // console.log("Blur.", editor);
            }}
            onFocus={(event, editor) => {
              // console.log("Focus.", editor);
            }}
          />
          {conditionTemplateHelperText && (
            <Typography sx={{ ...helperText }}>
              {' '}
              {conditionTemplateHelperText}{' '}
            </Typography>
          )}
        </Box>
      </div>
      <Box width={'fit-Content'} ml={'auto'} mt={'10px'}>
        <Button
          style={{
            fontSize: '1.6rem',
            lineHeight: '2.4rem',
            color: '#FFF',
            backgroundColor: '#155EEF',
            borderRadius: '0.8rem',
          }}
          padding={'0.8rem 2.6rem'}
          btnName={'Save Changes'}
          disable={(conditionTemplate === '' || uploadImage === '')}
          clicked={handleSubmit}
        />
      </Box>

      {copyUrlModal && <ViewPayloadAndErrorDetailsModal
        open={Boolean(copyUrlModal)}
        handleClose={() => {
          setCopyUrlModal(false);
        }}
        heading={"Digital Cost Sheet Url"}
        displayMsg={copyUrl}
        copyFlag={true}
      />}

    </div>
  );
};

export default DigitalCostSheet;
